define.alias("ember-composable-helpers/helpers/entries", "calendar/helpers/entries");